export enum PillarBoxColor {
    DARK_MINT = 'dark-mint',
    BERRY = 'berry',
    PURPLE = 'purple',
    MINT = 'mint',
    MIDNIGHT_BLUE = 'midnight-blue',
    ORANGE = 'orange',
    LIME_LIGHT = 'lime-light',
    LIGHT_BLUE = 'light-blue'
  }
  